import React from 'react';
import {
  Button,
  Box,
  Typography
} from '@mui/material';
import { GitHub as GitHubIcon } from '@mui/icons-material';

const GitHubSignInButton = ({ onSuccess, onError, disabled = false, variant = 'contained', size = 'large' }) => {
  const handleGitHubLogin = async () => {
    try {
      // Check if GitHub client ID is configured
      const clientId = process.env.REACT_APP_GITHUB_CLIENT_ID;
      if (!clientId || clientId === 'your-github-client-id') {
        console.error('GitHub Client ID not configured');
        if (onError) {
          onError(new Error('GitHub OAuth not configured. Please contact support.'));
        }
        return;
      }

      // Use the domain configured in GitHub OAuth app
      const redirectUri = 'https://liferunbooks.com/github-callback.html';
      const scope = 'user:email';
      
      // Generate state parameter for security
      const state = Math.random().toString(36).substring(7);
      localStorage.setItem('github_oauth_state', state);
      
      console.log('Starting GitHub OAuth flow...');
      console.log('Client ID:', clientId);
      console.log('Redirect URI:', redirectUri);
      
      // Open GitHub OAuth in a popup window
      const githubAuthUrl = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&state=${state}`;
      
      const popup = window.open(
        githubAuthUrl,
        'github-oauth',
        'width=600,height=700,scrollbars=yes,resizable=yes'
      );
      
      if (!popup) {
        throw new Error('Popup blocked. Please allow popups for this site.');
      }
      
      // Listen for messages from the popup
      const messageListener = (event) => {
        if (event.data && event.data.type === 'github_login_success') {
          console.log('GitHub login success message received:', event.data);
          window.removeEventListener('message', messageListener);
          
          if (onSuccess) {
            onSuccess(event.data.data);
          }
        }
      };
      
      window.addEventListener('message', messageListener);
      
      // Check if popup was closed
      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed);
          window.removeEventListener('message', messageListener);
          console.log('GitHub OAuth popup was closed');
        }
      }, 1000);
    } catch (error) {
      console.error('GitHub login error:', error);
      if (onError) {
        onError(error);
      }
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleGitHubLogin}
      disabled={disabled}
      sx={{
        bgcolor: variant === 'contained' ? '#24292e' : 'transparent',
        color: variant === 'contained' ? 'white' : '#24292e',
        border: variant === 'outlined' ? '1px solid #24292e' : 'none',
        '&:hover': {
          bgcolor: variant === 'contained' ? '#1b1f23' : 'rgba(36, 41, 46, 0.04)',
        },
        '&:disabled': {
          bgcolor: variant === 'contained' ? 'rgba(36, 41, 46, 0.38)' : 'transparent',
          color: variant === 'contained' ? 'rgba(255, 255, 255, 0.38)' : 'rgba(36, 41, 46, 0.38)',
        }
      }}
      fullWidth
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <GitHubIcon />
        <Typography variant="button">
          Continue with GitHub
        </Typography>
      </Box>
    </Button>
  );
};

export default GitHubSignInButton;